export default __webpack_public_path__ + "static/media/desapintar.3166710d.png";